// extracted by mini-css-extract-plugin
export default {"flip":"FlipButton-module__[local]___4rpSP","gray":"FlipButton-module__[local]___WvpSC","white":"FlipButton-module__[local]___MBT9i","btn":"FlipButton-module__[local]___g3IYQ"};